import { Enviroment } from "./models";

export const environment: Enviroment = {
  production: false,
  backendUrl: 'https://backend-homolog.greenant.com.br',
  sailsUrl: 'https://backend-homolog.greenant.com.br'
};